__turbopack_context__.v({
  "menu": "xN2igG_menu",
  "menu-selected": "xN2igG_menu-selected",
  "menumobile": "xN2igG_menumobile",
});
